import { createSlice } from "@reduxjs/toolkit";

import { PURGE } from "redux-persist";
import { createCompanyPreference, deleteFinancialYear } from "../../graphql";
import { fetchUserPreference, setRemoveFY } from "./UserPreference";
import { setRemoveCompanyRelatedFY } from "./CompanySlice";
import { showErrorSnackbar } from "../../components/snackBar/snakbar";
import { companyPreferenceApi } from "../apis/companyPreference.api";
import { API, graphqlOperation } from "aws-amplify";



export const conditionalResetState = ({ isCheck = false }) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { isCompleted, newFYDta } = state.newFyStepsReducer;
    if (!isCompleted && isCheck) {
      localStorage.setItem('fyDeletionInProgress', 'true');
      localStorage.setItem('fyToDelete', newFYDta?.financialyearid);
      localStorage.setItem('companyId', newFYDta?.companyid);

      try {
        await API.graphql(
          graphqlOperation(deleteFinancialYear, {
            financialyearid: newFYDta?.financialyearid,
          })
        );
        localStorage.removeItem('fyDeletionInProgress');
        localStorage.removeItem('fyToDelete');
        localStorage.removeItem('companyId');
      } catch (error) {
        console.error("Failed to delete financial year:", error);
        showErrorSnackbar("Failed to delete financial year");
        localStorage.removeItem('fyDeletionInProgress');
        localStorage.removeItem('fyToDelete');
        localStorage.removeItem('companyId');
        return;
      }

      try {
        await API.graphql(
          graphqlOperation(createCompanyPreference, {
            createCompanyPreferenceInput: {
              additionalvalue: "",
              attributetypecd: "NewFY Creation",
              attributevalue: 0,
            }
          })
        );
      } catch (error) {
        console.error("Failed to create company preference:", error);
        showErrorSnackbar("Failed to create company preference");
        return;
      }

      dispatch(setRemoveFY(newFYDta?.financialyearid));
      dispatch(setRemoveCompanyRelatedFY({
        companyid: newFYDta?.companyid,
        fyid: newFYDta?.financialyearid
      }));
      dispatch(companyPreferenceApi.util.invalidateTags(['listCompanyPreference']));
      dispatch(fetchUserPreference());
    } else {
      const incompleteDeletion = localStorage.getItem('fyDeletionInProgress');
      const fyToDelete = localStorage.getItem('fyToDelete');
      const companyId = localStorage.getItem('companyId');

      if (incompleteDeletion === 'true' && fyToDelete) {
        dispatch(setRemoveFY(fyToDelete));
        dispatch(setRemoveCompanyRelatedFY({
          companyid: companyId,
          fyid: fyToDelete
        }));

        localStorage.removeItem('fyDeletionInProgress');
        localStorage.removeItem('fyToDelete');
        localStorage.removeItem('companyId');
      }
    }



  } catch (error) {

    console.error("Failed to reset state:", error);

  }
};


const INITIAL_STATE = {
  activeStep: 0,
  newFY: "",
  startFy: "",
  endFy: "",
  currentFYDta: {},
  selectedCompanyId: null,
  newFYDta: {},
  startTimestamp: "",
  endTimestamp: "",
  companyEntity: {},
  companyDetails: {},
  updateCompanyDetails: 0,
  GroupLedger: 1,
  closingBalance: 0,
  AccountIds: "",
  GroupIds: "",
  isEnableEInvoice: true,
  ledgerTransfer: {
    active: 1,
    inactive: 0,
    closingBalance: 1,
  },
  partyTransfer: {
    active: 1,
    inactive: 0,
    closingBalance: 1,
  },
  itemTransfer: {
    active: 1,
    inactive: 0,
    closingBalance: 1,
  },
  backdropOpen: false,
  isCompleted: true,
};

const newFyStpesSlice = createSlice({
  name: "newFySteps",
  initialState: INITIAL_STATE,
  reducers: {
    updateStep: (state, action) => {
      state.activeStep += action.payload.increment ? 1 : -1;
    },
    setNewFYPreview: (state, action) => {
      const { newFY, startFy, endFy, startTimestamp, endTimestamp, newFYDta } =
        action.payload;
      Object.assign(state, {
        newFY,
        startFy,
        endFy,
        startTimestamp,
        endTimestamp,
        newFYDta,
      });
    },
    setFYData: (state, action) => {
      const { key, data } = action.payload;
      state[key] = data;
    },
    resetState: () => ({ ...INITIAL_STATE }),
    updateEntityDetails: (state, action) => {
      const { key, value, part } = action.payload;
      state[part][key] = value;
    },
    genericUpdate: (state, action) => {
      const { key, value } = action.payload;
      if (state?.hasOwnProperty(key)) {
        state[key] = value;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE);
  },
});

export const {
  updateStep,
  setNewFYPreview,
  setFYData,
  resetState,
  updateEntityDetails,
  genericUpdate,
} = newFyStpesSlice.actions;
export default newFyStpesSlice.reducer;
